
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 23 23","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"14.994","x2":"5.807","y1":"11.638","y2":"12.931"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#35bdd1"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d3db37"}})]),_c('linearGradient',{attrs:{"id":"a"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#35bdd1"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d7df38"}})]),_c('linearGradient',{attrs:{"id":"c","gradientUnits":"userSpaceOnUse","x1":"22.973","x2":"17.637","xlink:href":"#a","y1":"9.152","y2":"6.616"}}),_c('linearGradient',{attrs:{"id":"d","gradientUnits":"userSpaceOnUse","x1":"19.657","x2":"17.639","xlink:href":"#a","y1":"6.15","y2":"6.051"}}),_c('circle',{attrs:{"cx":"11.5","cy":"11.5","fill":"#122771","r":"11.5"}}),_c('path',{attrs:{"d":"M5.725 13.526c-.34.588.136 1.361.805 1.309l1.918-.15c.166-.014.248-.02.323.013.075.033.13.1.242.236l1.287 1.568c.45.547 1.28.352 1.407-.33l.513-2.248c.042-.183.063-.275.122-.339.06-.063.147-.087.322-.134l1.55-.42c.618-.25.656-1.144.064-1.513l-1.693-1.057c-.147-.092-.22-.138-.265-.21-.044-.072-.052-.16-.07-.334l-.193-2.008c-.067-.701-.875-1.058-1.367-.604l-1.407 1.3c-.122.112-.184.17-.261.187-.078.019-.16-.004-.323-.05L6.81 8.216c-.659-.184-1.196.489-.908 1.138l.821 1.858c.072.163.108.245.105.329s-.047.158-.132.306z","fill":"url(#b)"}}),_c('g',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".667"}},[_c('path',{attrs:{"d":"M15.834 9.911h3.233","stroke":"url(#c)"}}),_c('path',{attrs:{"d":"M17.45 8.417v2.986","stroke":"url(#d)"}})])])
          )
        }
      }
    